<script>
    import { Info, DateTime } from "luxon";

    export let selectedDate = DateTime.local();
    export let sundayStart = true;
    
    const today = DateTime.local();
    const weekdays = Info.weekdays('short');

    $: selectedMonth = today;
    $: startOfMonth = selectedMonth.startOf('month');
    $: firstOfMonth = !sundayStart ? startOfMonth.weekday : (startOfMonth.weekday % 7) + 1;  // 1-Mon, 7-Sun
    $: daysOfMonth = getDaysInMonth(selectedMonth);


    function getDaysInMonth(date) {
        const dom = date.daysInMonth
        let now = 1;
        let days = [];
        
        while(now <= dom) {
            let day = DateTime.local(date.year, date.month, now);
            days.push(day);
            now++;
        }

        return days;
    }

    function areSameDate(left, right) {
        return left.year === right.year && left.month === right.month && left.day === right.day;
    }

    function datesLT(left, right) {
        return left.year <= right.year && left.month <= right.month && left.day < right.day;
    }
    
    function gotoPrevMonth() {
        selectedMonth = selectedMonth.minus({months: 1});
    }

    function gotoNextMonth() {
        selectedMonth = selectedMonth.plus({months: 1});
    }

    function resetToToday() {
        selectedMonth = today;
        selectedDate = today;
    }

    function setSelectedDate(event) {
        if(event.target.nodeName == "BUTTON") {
            selectedDate = DateTime.local(selectedMonth.year, selectedMonth.month, Number(event.target.innerText));
        }
    }

</script>

<div class="main">
    <div class="header-grid">
        <div class="header-month">{selectedMonth.toFormat("MMMM yyyy")}</div>
        <div class="header-prev-month" title="Previous Month">
            {#if selectedMonth <= today}
            <button disabled>〈</button>
            {:else}
            <button on:click={gotoPrevMonth}>〈</button>
            {/if}
        </div>
        <div class="header-today" title="Today"><button on:click={resetToToday}>⟲</button></div>
        <div class="header-next-month" title="Next Month"><button on:click={gotoNextMonth}>〉</button></div>
    </div>
    <div class="weekday-grid">
        <div>{sundayStart ? weekdays[6] : weekdays[0]}</div>
        <div>{sundayStart ? weekdays[0] : weekdays[1]}</div>
        <div>{sundayStart ? weekdays[1] : weekdays[2]}</div>
        <div>{sundayStart ? weekdays[2] : weekdays[3]}</div>
        <div>{sundayStart ? weekdays[3] : weekdays[4]}</div>
        <div>{sundayStart ? weekdays[4] : weekdays[5]}</div>
        <div>{sundayStart ? weekdays[5] : weekdays[6]}</div>
    </div>

    <div class="month-grid">
    {#each daysOfMonth as date}
        {#if date.day == 1}
            <button 
                class="day-btn"

                class:is-today={areSameDate(date, today)}
                class:is-selected={areSameDate(date, selectedDate)}
                style="grid-column: {firstOfMonth}" 
                on:click={setSelectedDate}
                disabled={datesLT(date, today)}
            >
                {date.day}
            </button>
        {:else}
            <button 
                class="day-btn"
                class:is-today={areSameDate(date, today)}
                class:is-selected={areSameDate(date, selectedDate)}
                on:click={setSelectedDate}
                disabled={datesLT(date, today)}
            >
                {date.day}
            </button>
        {/if}
        
    {/each}
    </div>
</div>

<style>
button {
    border: 0;
    background-color: transparent;
}

.main {
    max-width: max-content;
    margin: 1em auto 0 auto;
    padding: 1.5em;
    border: 1px solid var(--blugry-main);
    border-radius: 8px;
    background-color: white;
}

.header-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-column-gap: 5px;
    grid-row-gap: 5px;
}

.header-month { 
    grid-area: 1 / 1 / 2 / 5;
    margin-top: 0.5em;
}
.header-prev-month { grid-area: 1 / 5 / 2 / 6; }
.header-today { grid-area: 1 / 6 / 2 / 7; }
.header-next-month { grid-area: 1 / 7 / 2 / 8; }

.weekday-grid,
.month-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-column-gap: 5px;
    grid-row-gap: 5px;
}

.weekday-grid {
    margin-bottom: 0.5em;
}

.day-btn {
    border-radius: 20%;
    padding: 8px;
}

.day-btn:hover:not(:disabled),
.day-btn:focus:not(:disabled) {
    outline: none;
    background-color: var(--grn-lighter);
    color: var(--grn-darker);
}

.day-btn.is-today {
    padding: 6px;
    border: 2px solid var(--blugry-lighter);
}

.day-btn.is-selected {
    padding: 6px;
    border: 2px solid var(--grn-darker);
    background-color: var(--grn-lighter);
    color: var(--grn-darker);
}

@media (max-width: 320px) {
	.main {
        font-size: 0.9em;
    }

    .day-btn {
        padding: 4px;
    }
}

</style>